<template>
  <el-tooltip
    class="item"
    effect="dark"
    placement="top-start"
    :content="text"
    popper-class="tooltip-width"
  >
    <span class="tooltip-text" style="display: inline-block">{{ text }}</span>
  </el-tooltip>
</template>
<script>
export default {
  name: "RtTooltip",
  props: {
    text: {
      type: String,
    },
  },
};
</script>
<style scoped>
.tooltip-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// index.vue?69260ea4